import {OnInit, Injectable} from '@angular/core';

declare let THREE: any;
import {RotateHandlerBase} from './RotateHandlerBase';
import {StageService} from '../../../../services/stage.service';
import {ObjectCheckerService} from '../../../../services/object-checker.service';
import {CollisionService} from '../../../../services/collision/collision.service';
import {GeometryHelperService} from '../../../../services/geometry-helper.service';
import {Select3dService} from '../../../../services/select-3d.service';

@Injectable()
export class ClockwiseRotateHandler extends RotateHandlerBase {

  constructor(
    protected stageService: StageService,
    protected objectCheckerSrvc: ObjectCheckerService,
    protected collisionSrvc: CollisionService,
    protected geometryHelper: GeometryHelperService,
    protected Select3D: Select3dService
  ) {
    super(
      'rotateClockwise',
      -1,
      stageService,
      objectCheckerSrvc,
      collisionSrvc,
      geometryHelper,
      Select3D
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/Handlers/ClockwiseRotateHandler.ts